var autoFocusDirective = function($parse) {
  return {
    link: function(scope, element, attrs) {
      var focus_el = element.find('input')[0] || element.find('textarea')[0];

      if (attrs.hasOwnProperty('focusonopen')) {
        var getter = $parse(attrs.focusonopen);
        if (getter(scope)) {
          focus_el.focus();
        }
      } else {
        focus_el.focus();
      }
    }
  }
};

autoFocusDirective.$inject = ['$parse'];

tiz.directive('autoFocus', autoFocusDirective);

var autoFocusOnShowDirective = function($parse, $timeout) {
  return {
    link: function(scope, element, attrs) {
      var focus_el = element.find('input')[0] || element.find('textarea')[0];

      scope.$watch(attrs.focusonshow, function(newValue) {
        $timeout(function() {
          if (newValue) { focus_el.focus() };
        });
      });
    }
  };
};

autoFocusOnShowDirective.$inject = ['$parse', '$timeout'];

tiz.directive('autoFocusOnShow', autoFocusOnShowDirective);
